var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogFormDialog',{ref:"dialog",attrs:{"strings":_vm.strings},on:{"reset":_vm.reset}},[_c('v-text-field',{attrs:{"rules":_vm.rules,"label":_vm.strings.nameLabel,"placeholder":_vm.placeholder,"type":"text"},model:{value:(_vm.values.name),callback:function ($$v) {_vm.$set(_vm.values, "name", $$v)},expression:"values.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }